export const TREATMENT_PLAN_UPLOAD_ACCEPT = {
    smileDesignPPT:
        '.ppt, .pptx, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/pdf',
    smileDesign_exocad_pre: '.html',
};

export const allowedExtensions = {
    smileDesignPPT: ['.ppt', '.pptx', '.pdf'],
    smileDesign_exocad_pre: ['.html'],
};

const allowedMimeTypes = {
    smileDesignPPT: [
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/pdf',
    ],
    smileDesign_exocad_pre: [],
};

export function isValidTreatmentPlanUpload(file, stateType) {
    if (!allowedExtensions[stateType]) {
        return true;
    }
    if (!file || typeof file.name !== 'string') {
        return false;
    }

    const extension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
    const mimeType = typeof file.type === 'string' ? file.type.toLowerCase() : '';
    return allowedExtensions[stateType].includes(extension) || allowedMimeTypes[stateType].includes(mimeType);
}